import { StrictMode } from "react"
import * as ReactDOM from "react-dom"
import { createFeatureHub } from "@feature-hub/core"
import { loadFederatedModule } from "@feature-hub/module-loader-federation"
import { FeatureHubContextProvider } from "@feature-hub/react"
import { RouterProvider } from "react-router"
import { createBrowserRouter } from "react-router-dom"
import App from "App"
import "./i18n"
import { defineStoreFeatureService } from "@client-hub/store/store.feature-service"
import { VERSIONS as StoreVersions, ID as storeId } from "@client-hub/store/constants"
import { INTEGRATOR_ID, SERIALIZED_STATE_SCRIPT_TYPE } from "constants/config"
import type { AppStore } from "@client-hub/store/createStore"
import { Persistor } from "redux-persist"
import { defineSerializedStateManager } from "@feature-hub/serialized-state-manager"
import { CacheProvider } from "@emotion/react"
import createEmotionCache from "utils/createEmotionCache"
import "@icanbwell/ui-toolkit/dist/index.css"
import { routeMap } from "routeMap"

const { featureAppManager, featureServices } = createFeatureHub(INTEGRATOR_ID, {
  featureServiceDefinitions: [
    defineSerializedStateManager(
      document.querySelector(`script[type="${SERIALIZED_STATE_SCRIPT_TYPE}"]`)?.textContent || "",
    ),
    defineStoreFeatureService({ domain: window.location.hostname }),
  ],
  featureServiceDependencies: {
    [storeId]: StoreVersions.PRE_RELEASE,
  },
  moduleLoader: loadFederatedModule,
})

const cache = createEmotionCache()

const routes = [
  {
    element: (
      <StrictMode>
        <FeatureHubContextProvider value={{ featureAppManager }}>
          <CacheProvider value={cache}>
            <App {...(featureServices[storeId] as { store: AppStore; persistor: Persistor })} />
          </CacheProvider>
        </FeatureHubContextProvider>
      </StrictMode>
    ),
    children: routeMap,
  },
]
const router = createBrowserRouter(routes)

ReactDOM.hydrate(<RouterProvider router={router} />, document.getElementById("root"))
